import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "save",
  "use": "save-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol viewBox=\"0 0 15 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"save\">\n<path d=\"M14.0312 3.0625L11.4062 0.4375C11.1875 0.21875 10.7188 0 10.375 0H2.5C1.375 0 0.5 0.90625 0.5 2V12C0.5 13.125 1.375 14 2.5 14H12.5C13.5938 14 14.5 13.125 14.5 12V4.125C14.5 3.78125 14.2812 3.3125 14.0312 3.0625ZM7.5 12C6.375 12 5.5 11.125 5.5 10C5.5 8.90625 6.375 8 7.5 8C8.59375 8 9.5 8.90625 9.5 10C9.5 11.125 8.59375 12 7.5 12ZM10.5 5.5C10.5 5.78125 10.25 6 10 6H3C2.71875 6 2.5 5.78125 2.5 5.5V2.5C2.5 2.25 2.71875 2 3 2H10C10.25 2 10.5 2.25 10.5 2.5V5.5Z\" fill=\"#26A69A\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/save.svg
// module id = V6Hz
// module chunks = 13